export {
  createMockInterceptor,
  initMockInterceptor,
  initMockInterceptorForPureHttp,
  setMockEnabled,
  isMockEnabled,
  loadMockData,
  registerHttpInstance
} from './interceptor'

export type { MockInterceptorOptions, MockBundleData } from './interceptor'
